module.exports = __webpack_public_path__ + "img/631.eb95c4bb.jpg";